import { HttpClient } from '../HttpClient';
/**
 * * Get all monthly statements
 **/

export const GetStatementsMonthly = async ({
  year = null,
  month = null,
  PageNumber,
}) => {
  try {
    const response = await HttpClient.get('/api/instacash/statements/monthly', {
      params: {
        ...(year ? { year: year } : {}),
        ...(month ? { month: month } : {}),
        ...(PageNumber ? { PageNumber: PageNumber } : {}),
      },
    });
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
